/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

if (!customElements.get('our-story-awards')) {
  class OurStoryAwards extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[data-award-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-award-panel]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab), {
          signal: this.controller.signal,
        });
        tab.addEventListener('keydown', (event) => this.onKeydown(event), {
          signal: this.controller.signal,
        });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    selectTab(tab, options = {}) {
      if (!this.tabs.includes(tab)) return;

      this.tabs.forEach((candidate) => {
        const selected = candidate === tab;
        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (options.focus) tab.focus();

      if (options.scroll && this.querySelector('.our-story-awards__timeline')?.scrollWidth > this.clientWidth) {
        tab.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;

      const isRtl = document.documentElement.dir === 'rtl';
      let nextIndex;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = (currentIndex + (isRtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
          break;
        case 'ArrowLeft':
          nextIndex = (currentIndex + (isRtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.selectTab(this.tabs[nextIndex], { focus: true, scroll: true });
    }
  }

  customElements.define('our-story-awards', OurStoryAwards);
}
